import { faFlag, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Alert, Button, Col, Modal, Row, Table } from "react-bootstrap";
import BihamtaTable from "../../../Components/BihamtaTable";
import { addOrUpdateServiceStatus, getServiceStatusListForManage, deleteServiceStatus } from "../../store/api/Services";
import { useDispatch } from "react-redux";
import { isWebApp, setErrorDialog } from "../../../store/api/CommonFunctions";
import ServiceStages from "../../content/images/ServiceStages.png";
import { CheckLg, DashCircle, PencilFill, PlusSquareFill } from "react-bootstrap-icons";

const ModalServiceStatusManagement = (props) => {
    const { show, close } = props;
    const dispatch = useDispatch();
    const [current, setCurrent] = useState(null);
    const [dataList, setDataList] = useState();
    const [submitError, setSubmitError] = useState(null);
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "Status", colTitle: "نام وضعیت", showInMobile: true },
        { colName: "StatusMessage", colTitle: "نام قابل نمایش به مشتری", showInMobile: true },
        { colName: "ReceptionState", colTitle: "پذیرش", colType: "boolean" },
        { colName: "DistributionState", colTitle: "توزیع کار", colType: "boolean" },
        { colName: "WorkshopState", colTitle: "تعمیرگاه", colType: "boolean" },
        { colName: "ReadyToDelivery", colTitle: "آماده تحویل", colType: "boolean" },
        { colName: "ReadyToSend", colTitle: "آماده ارسال", colType: "boolean" },
        { colName: "DeliveryState", colTitle: "تحویل", colType: "boolean" },
        { colName: "SendState", colTitle: "ارسال", colType: "boolean" }
    ]
    const rowButtons = [
        { type: "common", icon: <PencilFill color="orange" size={18} />, onclick: selectForEdit },
        { type: "delete", onclick: delStatus }
    ]
    function selectForEdit(row) {
        if (current) {
            setErrorDialog(dispatch, "ابتدا ردیف کنونی را به سرانجام برسانید","مدیریت وضعیت سرویس");
            return;
        }
        delete row.e;
        setCurrent(row);
    }
    function prepareForAdd() {
        setCurrent({ ID: 0 });
    }
    function cancelCurrent() {
        setCurrent(null);
    }
    function submitStatus() {
        setSubmitError(null);
        if ((current.Status ?? "") === "") {
            setSubmitError("نام وضعیت وارد نشده است");
            return;
        }
        const onAddEdit = (res) => {
            if (res.Data) {
                // setErrorDialog(dispatch, "success","ثبت/ویرایش سرویس");
                getServiceStatusListForManage(setDataList);
                setCurrent(null);
            }
            else if (res.Error) {
                setSubmitError(res.Error);
            }

        }
        addOrUpdateServiceStatus(current, onAddEdit);
    }
    function delStatus(row) {
        if (current) {
            setErrorDialog("ابتدا ردیف کنونی را به سرانجام برسانید");
            return;
        }
        const onDelete = (res) => {
            if (res.Data) {
                setDataList({Data:dataList.Data.filter(s => Number(s.ID) !== Number(row.ID))});
            }
            else if (res.Error) {
                setSubmitError(res.Error);
            }

        }
        deleteServiceStatus(row.ID, onDelete);
    }
    function onClose(){
        setCurrent(null);
        close();
    }
    useEffect(() => {
        if (show)
            getServiceStatusListForManage(setDataList);
    }, [show])
    return (
        <Modal show={show} size="xl" onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faFlag} size="lg"/>&nbsp;
                    مدیریت وضعیت سرویس
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={onClose} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {submitError &&
                    <Alert variant="danger">
                        {submitError}
                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                    </Alert>}
                <PlusSquareFill size={25} className="hoverIcon mb-1" onClick={prepareForAdd} color="#134df3" style={{ cursor: "pointer" }} />
                {current &&
                    <Row className="rowBorder scThin" style={{ overflow: "auto" }}>
                        <table style={{ whiteSpace: "nowrap", minWidth: "750px" }}>
                            <thead>
                                <th style={{ padding: "5px" }}>نام وضعیت</th>
                                <th style={{ padding: "5px" }}>نام نمایشی</th>
                                <th style={{ padding: "5px" }}>پذیرش</th>
                                <th style={{ padding: "5px" }}>توزیع کار</th>
                                <th style={{ padding: "5px" }}>تعمیرگاه</th>
                                <th style={{ padding: "5px" }}>آماده تحویل</th>
                                <th style={{ padding: "5px" }}>آماده ارسال</th>
                                <th style={{ padding: "5px" }}>تحویل</th>
                                <th style={{ padding: "5px" }}>ارسال</th>
                                <th style={{ padding: "5px" }}>رنگ</th>
                            </thead>
                            <tbody>
                                <td style={{ padding: "5px" }}><input className="tableRowInput" defaultValue={current.Status ?? ""} onChange={e => current.Status = e.target.value} /></td>
                                <td style={{ padding: "5px" }}> <input className="tableRowInput" defaultValue={current.StatusMessage ?? ""} onChange={e => current.StatusMessage = e.target.value} /></td>
                                <td style={{ padding: "5px" }}><input type="checkbox" className="form-check-input" onChange={e => current.ReceptionState = e.target.checked}
                                    defaultChecked={current.ReceptionState} /></td>
                                <td style={{ padding: "5px" }}> <input type="checkbox" className="form-check-input" defaultChecked={current.DistributionState} onChange={e => current.DistributionState = e.target.checked} /></td>
                                <td style={{ padding: "5px" }}> <input type="checkbox" className="form-check-input" defaultChecked={current.WorkshopState} onChange={e => current.WorkshopState = e.target.checked} /></td>
                                <td style={{ padding: "5px" }}> <input type="checkbox" className="form-check-input" defaultChecked={current.ReadyToDelivery} onChange={e => current.ReadyToDelivery = e.target.checked} /></td>
                                <td style={{ padding: "5px" }}> <input type="checkbox" className="form-check-input" defaultChecked={current.ReadyToSend} onChange={e => current.ReadyToSend = e.target.checked} /></td>
                                <td style={{ padding: "5px" }}> <input type="checkbox" className="form-check-input" defaultChecked={current.DeliveryState} onChange={e => current.DeliveryState = e.target.checked} /></td>
                                <td style={{ padding: "5px" }}> <input type="checkbox" className="form-check-input" defaultChecked={current.SendState} onChange={e => current.SendState = e.target.checked} /></td>
                                <td style={{ padding: "5px" }}><input type="color" defaultValue={current.BackgroundColor ?? "#ece4e4"} onChange={e => current.BackgroundColor = e.target.value} /></td>
                            </tbody>
                        </table>
                        <div>
                            <Button className="group-Btn" variant="success" onClick={submitStatus}><CheckLg size={16} />&nbsp; ثبت اطلاعات</Button>
                            <Button className="group-Btn" variant="danger" onClick={cancelCurrent}><DashCircle size={16} />&nbsp; انصراف</Button>
                        </div>
                    </Row>
                }
                <BihamtaTable rowButtons={rowButtons} columns={tableCols} dataList={dataList} style={{ whiteSpace: "nowrap" }} maxHeight={500} className="mt-0 mb-0" />
                {isWebApp() &&
                    <div style={{ textAlign: "center", height: "20vh" }}>
                        <img src={ServiceStages} height="100%" />
                    </div>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalServiceStatusManagement;